export default __webpack_public_path__ + "src/components/pages/userInterfaceSettings/livePreview/skins/3cb51c90f024eacc77c1c306b4d377e2.png";